import type { AuthenticatorAssuranceLevels, SupabaseClient } from '@supabase/supabase-js';
import { err, ok } from 'neverthrow';
import { wrapResultAsyncFunction } from '.';

export const requiresAalStepUp = (
	currentLevel: AuthenticatorAssuranceLevels | null,
	requiredLevel: AuthenticatorAssuranceLevels | null,
): boolean => requiredLevel === 'aal2' && requiredLevel !== currentLevel;

export const checkIfAalStepUpRequiredAsync = wrapResultAsyncFunction(async (supabaseClient: SupabaseClient) => {
	const { data, error } = await supabaseClient.auth.mfa.getAuthenticatorAssuranceLevel();

	if (error) {
		return err(error);
	}

	return ok(requiresAalStepUp(data.currentLevel, data.nextLevel));
});
